export const travelIndexedDB = 'ng-rappi-travel';
export const travelSearchDB = 'SearchDB';
export const travelSearchDBData = 'data';
